import '../Components/FooterStyles.css'
import {FaHome, FaPhone,FaMailBulk, FaTwitter, FaFacebook, FaLinkedin, FaInstagram} from 'react-icons/fa'

const Footer=()=>{
    return(
        <div className='footer'>
            <div className="left">
                <div className='icon'>
                
                        <div className='home'>
                            <FaHome size={20} style={{color:'white',marginRight:'1rem'}}/>
                            <p>H.no 232</p>
                        </div>
                        <div className='home'>
                            <FaPhone size={20} style={{color:'white',marginRight:'1rem'}}/>
                            <p>8882347432</p>
                        </div>
                        <div className='home'>
                            <FaMailBulk size={20} style={{color:'white',marginRight:'1rem'}}/>
                            <p>shakyaalok99@gmail.com</p>
                        </div>
  
                </div>
            </div>



            <div className="right">
                <h4>About the company</h4>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quasi reprehenderit odio fugiat facilis impedit molestias, eligendi explicabo. Nostrum, veniam perferendis.</p>
                <div className="social-icons">
                    <FaTwitter size={30}  style={{color:'white',marginRight:'1rem'}} />
                    <FaFacebook size={30}  style={{color:'white',marginRight:'1rem'}} />
                    <FaLinkedin size={30}  style={{color:'white',marginRight:'1rem'}} />
                    <FaInstagram size={30}  style={{color:'white',marginRight:'1rem'}} />
                </div>
            </div>



        </div>
    )
}



export default Footer;